<template>
    <div v-redirect-if-no-permission:PAYMENT_METHODS>
        <DataTable ref="datatable" :url="api.ACTIONS.PAYMENT_METHODS"
            :formatter="formatter"
            :enable-add="false"
            :fieldsHiddenEdit='["id"]'
            :actionsExtraMain="actionsExtraMain" :conditional-action="conditionalAction"
            :fields-extra-edit="extraEditor"
            :forceReload="true" :edit-rules="rules(false)" :enableDelete="false"
            :titles="titles" :title='$t("catalogPage.pageTitlePaymentMethods")' />
    </div>
</template>

<script>

import DataTable from "@/components/monaco/DataTable";

export default {
    components: { DataTable },
    name: "PaymentMethods",
    title() {
        return this.$t("catalogPage.pageTitlePaymentMethods");
    },
    methods: {
        rules(add) {
            const required = value => !!value || this.$t("catalogPage.ruleRequired");
            const number = value => {
                const pattern = /^\d+$/;
                if (!!value)
                    return pattern.test(value) || this.$t("catalogPage.ruleNumber");
                else
                    return true;
            };
            return {
                name_en: [required],
                name_ar: [required],
                icon: [],
                priority: [number],
                merchant_account: [],
            }
        },
    },
    computed: {
        extraEditor() {
            return {
                icon: 'choose-image-single',
                active: 'v-checkbox'
            }
        },
        formatter() {
            const api = this.api;
            const vm = this;
            return {
                icon(value) {
                    if (value == null) return vm.$t("catalogPage.unloadable");
                    if (value[0] !== '/') value = "/" + value;
                    return `<img src="${api.IMAGES_URL + value}" class="img-thumbnail"/>`;
                },

                active(value) {
                    if (value == 0) {
                        return `<span style="color: red">${vm.$t("catalogPage.no")}</span>`;
                    }
                    return `<span style="color: green">${vm.$t("catalogPage.yes")}</span>`;
                }
            }
        },
        titles() {
            return {
                "id": "#",
                "name_en": this.$t("catalogPage.colNameEn"),
                "name_ar": this.$t("catalogPage.colNameAr"),
                "created_at": this.$t("catalogPage.colDateCreated"),
                "updated_at": this.$t("catalogPage.colLastDateUpdated"),
                "info": this.$t("catalogPage.colInfo"),
                "priority": this.$t("catalogPage.colPriority"),
                "merchant_account": this.$t("catalogPage.colMerchantAccount"),
                "icon": this.$t("catalogPage.colIcon"),
                "active": this.$t("catalogPage.colActive")
            }
        },

        conditionalAction() {
            return {
                activate(item) {
                    return !item.active;
                },
                deactivate(item) {
                    return item.active;
                }
            }
        },
        actionsExtraMain() {
            return {


                activate: {
                    icon: 'check',
                    action: (item) => {
                        this.$dialova({
                            title: this.$t("catalogPage.activatePaymentMethodTitle"),
                            paragraph: this.$t("catalogPage.activatePaymentMethodConfirm", { name: item.name_en }),
                            loader: true,
                        })
                            .then(({ close }) => {
                                this.axios
                                    .put(`payment-method/activate/` + item.id)
                                    .then(() => {
                                        window.getApp.$emit(
                                            "SHOW_TOAST",
                                            this.$t("catalogPage.paymentMethodActivated"),
                                            "green"
                                        );
                                        this.$refs['datatable'].getData();
                                        close();
                                    })
                                    .catch((err) => {
                                        window.getApp.$emit("SHOW_TOAST", err.response.data.message || this.$t("catalogPage.errorOccurred"), "red");
                                        close();
                                    });
                            })
                            .catch(() => {
                                console.log("cancelled");
                            });
                    }
                },
                deactivate: {
                    icon: 'clear',
                    action: (item) => {
                        this.$dialova({
                            title: this.$t("catalogPage.deactivatePaymentMethodTitle"),
                            paragraph: `<p style="font-size: small;">${this.$t("catalogPage.inactivePaymentMethodsHint")}</p>` + this.$t("catalogPage.deactivatePaymentMethodConfirm", { name: item.name_en }),
                            loader: true,
                        })
                            .then(({ close }) => {
                                this.axios
                                    .put(`payment-method/activate/` + item.id)
                                    .then(() => {
                                        window.getApp.$emit(
                                            "SHOW_TOAST",
                                            this.$t("catalogPage.paymentMethodDeactivated"),
                                            "green"
                                        );
                                        this.$refs['datatable'].getData();
                                        close();
                                    })
                                    .catch((err) => {
                                        window.getApp.$emit("SHOW_TOAST", err.response.data.message || this.$t("catalogPage.errorOccurred"), "red");
                                        close();
                                    });
                            })
                            .catch(() => {
                                console.log("cancelled");
                            });
                    }
                }

            }
        }
    }
}
</script>

<style>
.img-thumbnail {
    max-height: 40px;
    max-width: 40px;
}
</style>
